import uploadTool from './uploadTool.vue'

let UploadTool = {}

// 只有定义了 install 方法，才能使用 Vue.use() 进行引用
UploadTool.install = function (Vue) {
  // 添加实例方法 - 扩展方法
  const UploadToolController = Vue.extend(uploadTool)
  let instance = new UploadToolController().$mount(document.createElement('div'))
  document.body.appendChild(instance.$el)
  Vue.prototype.$uploadTool = function (album, camera) {
    instance.pullBox = true
    instance.cont = true
    instance.camera = camera
    instance.album = album
  }
}

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(UploadTool)
}

export default UploadTool



// WEBPACK FOOTER //
// ./src/components/base/uploadTool/index.js